// https://github.com/iamkun/dayjs/blob/dev/docs/en/Plugin.md#localizedFormat
export const DEFAULT_DATE_FORMAT = 'LL'
export const DEFAULT_DATETIME_FORMAT = 'LLL'
export const FORMAT_MONTH_YEAR = 'MMM. YYYY'
export const SHORT_DATE_FORMAT = 'L'
